import React from 'react'
import { AsterChip } from 'asterX-UI/Chip'
import { GRAY_COLORS, SUCCESS_COLORS, ERROR_COLORS, WARNING_COLORS } from 'asterX-UI'
import { ChevronRight } from '@material-ui/icons'
import { getValidDate } from '../../../lib/utils'

const money = v => (v || v === 0 ? `${Number(v).toLocaleString('ru-RU')} ₸` : '-')

const wlStatusMeta = s => {
  switch (s) {
    case 'IN_PROGRESS':
    case 'IN_PROGRESS_LAWYER':
      return { label: 'В работе', style: { background: WARNING_COLORS[100], color: WARNING_COLORS[800] } }
    case 'COMPLETED':
      return { label: 'Завершен', style: { background: SUCCESS_COLORS[100], color: SUCCESS_COLORS[800] } }
    case 'REJECTED':
      return { label: 'Отклонен', style: { background: ERROR_COLORS[100], color: ERROR_COLORS[800] } }
    default:
      return { label: s || '-', style: { background: GRAY_COLORS[100], color: GRAY_COLORS[800] } }
  }
}
const applicationStatusMeta = s => {
  switch (s) {
    case 'SUBMITTED':
      return { label: 'На согласовании', style: { background: WARNING_COLORS[100], color: WARNING_COLORS[800] } }
    case 'COMPLETED':
      return { label: 'Согласовано', style: { background: SUCCESS_COLORS[100], color: SUCCESS_COLORS[800] } }
    case 'REJECTED':
      return { label: 'Отклонено', style: { background: ERROR_COLORS[100], color: ERROR_COLORS[800] } }
    default:
      return { label: s || '-', style: { background: GRAY_COLORS[100], color: GRAY_COLORS[800] } }
  }
}

export const applicationColumns = () => [
  'Номер договора',
  'Тип заявления',
  'ФИО заемщика',
  'ИИН',
  '№ продукта',
  'Дней просрочки',
  'ОД (основной долг)',
  'Остаток долга',
  'Дата заявки',
  'Статус рабочего листа',
  'Статус заявки',
  ''
]

/**
 * Когда появится applicationsList – маппинг под реальные поля заявок.
 */
export const applicationRowsFromApplications = (list = []) =>
  list.map(item => {
    const statusWl = wlStatusMeta(item?.workListStatusCode)
    const statusApplication = applicationStatusMeta(item?.status)
    return [
      item?.contractNumber || '-',
      item?.applicationType || '-',
      item?.clientFullName || '-',
      item?.clientIin || '-',
      item?.creditProducts.map(product => product.slice(0,4)).join(',') || '-',
      item?.overdueDays ?? '-',
      money(item?.loanAmount),
      money(item?.overdueTranchesSum),
      getValidDate(item?.createdDate),
      <AsterChip
        key={`wl-status-${item?.id}`}
        label={statusWl.label}
        style={{ ...statusWl.style, border: `1px solid ${GRAY_COLORS[200]}` }}
      />,
      <AsterChip
        key={`status-${item?.id}`}
        label={statusApplication.label}
        style={{ ...statusApplication.style, border: `1px solid ${GRAY_COLORS[200]}` }}
      />,
      {
        isButton: true,
        label: <ChevronRight />,
        data: { id: item?.id, rejectReason: item?.rejectionReason, status: item?.status }
      }
    ]
  })
/**
 * Временный маппинг из contractList, пока нет applicationsList.
 */
